import React, { useRef } from "react";
import PropTypes from "prop-types";

import { makeStyles } from "tss-react/mui";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import ComponentSuspense from "../../../../../../Common/ComponentSuspense";
import CopyButton from "../../../../../../Common/CopyButton";
import { useSelector } from "react-redux";
const MyAceEditor = React.lazy(() => import("../../../../../../Common/AceEditor"));

const useStyles = makeStyles()((theme) => ({
  queryArea: {
    width: "100% !important",
    height: "173px !important",
    border: "1px solid",
    fontSize: "0.7rem",
    "&::selection": { background: "#B9B9B9", color: "#000000" },
    "&::-moz-selection": { background: "#B9B9B9", color: "#000000" },
    "&::-webkit-selection": { background: "#B9B9B9", color: "#000000" },
  },
}));

const DataQualityQuery = ({ setQuery, setQueryError, query, cluster }) => {
  const { classes } = useStyles();
  const queryRef = useRef(null);

  const workspace = useSelector((state) => state.workspace);
  const user = useSelector((state) => state.user.currentUser);
  const User_id = user.User_id;

  const { DBName: workspaceDBName } = workspace.workspace;

  return (
    <Grid container spacing={1}>
      <Grid size={6}>
        <Typography color={"#00000099"} padding={0} variant="subtitle2" component="span">
          Data Quality Custom SQL (Optional)
        </Typography>
      </Grid>
      <Grid sx={{ paddingTop: "5px !important" }} size={12}>
        <Typography color={"#00000099"} padding={0} variant="caption" component="span" sx={{ mt: 1, mb: 1 }}>
          Use select query only. Query must include HK, SOURCE, ATTRIBUTE, RULE_NAME, CATEGORY, DESCRIPTION and ALERT
          fields.
          <br />
          Copy the sample query
          <CopyButton
            value={
              "select HK, record_source as SOURCE, 'TotalPrice' ATTRIBUTE, 'Custom_TotalPrice' RULE_NAME, 1 as CATEGORY, '' as DESCRIPTION, 'Critical' as Alert\nfrom Model.S_Product \nwhere END_DATE IS NULL AND TotalPrice != Quantity * UnitPrice"
            }
          />
        </Typography>
        <ComponentSuspense>
          <MyAceEditor
            fontSize={14}
            style={{ paddingTop: "10px" }}
            className={classes.queryArea}
            ref={queryRef}
            label="Query"
            value={query}
            setQuery={setQuery}
            location={"SNOWFLAKE"}
            type={"snowflake"}
            runParams={{
              database: workspaceDBName,
              schema: "MODEL",
              runJobAsUserId: User_id,
              cluster,
            }}
            onError={(error) => setQueryError(error)}
          />
        </ComponentSuspense>
      </Grid>
    </Grid>
  );
};

DataQualityQuery.propTypes = {
  query: PropTypes.string.isRequired,
  setQuery: PropTypes.func.isRequired,
};

export default React.memo(DataQualityQuery);
